// extracted by mini-css-extract-plugin
export default {"wrapper":"assetsPage__wrapper--WQSps","assetsContainer":"assetsPage__assetsContainer--Afhxp","ingress":"assetsPage__ingress--qLx0q","swishText":"assetsPage__swishText--C_l7Z"};